import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SuperMultiAutocomplete from 'common/components/form/SuperMultiAutocomplete'
import { getTicketOptions } from './DevLotsUtils'

const TICKETS_PROPOSED = 10
const CHIPS_SHOWN = 5

// Sélection multiple de tickets Mantis : les plus récents (id le plus haut) sont proposés en premier, 10 à la fois
// (« Voir plus » pour la suite), recherche par id ou par titre.
const TicketsPicker = ({ tickets = [], targetLot, values = [], onChange = () => {}, obligatory }) => {
    const options = useMemo(() => getTicketOptions(tickets, targetLot), [tickets, targetLot])

    return (
        <SuperMultiAutocomplete
            multiple
            label='Tickets'
            placeholder='Rechercher par id ou par titre'
            keyLabel='label'
            chipLabelKey='chipLabel'
            values={values}
            options={options}
            onChange={ids => onChange(ids.filter(id => Number.isFinite(id)))}
            maxOptions={TICKETS_PROPOSED}
            limit={CHIPS_SHOWN}
            disablePortal={false}
            noSort
            obligatory={obligatory}
        />
    )
}

TicketsPicker.propTypes = {
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
    targetLot: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.number),
    onChange: PropTypes.func,
    obligatory: PropTypes.bool,
}

export default TicketsPicker
